import React from "react";
import {
  Box,
  Typography,
  Rating,
  FormHelperText,
  TextField,
  Tooltip,
} from "@mui/material";

const DiveEnvironmentalInfo = ({
  visibilityRating,
  setVisibilityRating,
  visibilityRatingError,
  diveRating,
  setDiveRating,
  diveRatingError,
  waterTemperature,
  setWaterTemperature,
}) => {
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body1" component="p">
          Visibility:
        </Typography>
        <Tooltip title="Each star is about 10 feet of visibility.">
          <Rating
            value={visibilityRating}
            onChange={(event, newValue) => {
              setVisibilityRating(newValue);
            }}
          />
        </Tooltip>
        {visibilityRatingError && (
          <FormHelperText error>{visibilityRatingError}</FormHelperText>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body1" component="p">
          Overall dive experience:
        </Typography>
        <Tooltip title="1 star=no need to revisit, 5 stars=Love it, let's do it again.">
        <Rating
          value={diveRating}
          onChange={(event, newValue) => {
            setDiveRating(newValue);
          }}
        />
        </Tooltip>
        {diveRatingError && (
          <FormHelperText error>{diveRatingError}</FormHelperText>
        )}
      </Box>

      <TextField
        id="waterTemperature"
        label="Water Temperature (°F)"
        type="number"
        value={waterTemperature}
        onChange={(event) => {
          setWaterTemperature(event.target.value);
        }}
      />
    </>
  );
};

export default DiveEnvironmentalInfo;
